import config from "../../config";
import $ from "jquery";
import { useEffect, useState } from "react";
import "./style.css";
import Modal from "react-bootstrap/Modal";
import { useFormik } from "formik";
import cancel from "../../images/cancel.svg";
import expenseCategorySchema from "../../validations/expenseCategorySchema";

function ExpenseCategoryEdit(props) {
  const [isSubmit, setIsSubmit] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const expenseCategoryFormik = useFormik({
    initialValues: {
      exp_cat_name: props.id?.exp_cat_name,
      exp_cat_type: props.id?.exp_cat_type,
      exp_cat_id: props.id?.exp_cat_id,
    },
    validationSchema: expenseCategorySchema.validateExpCatEdit(),
    validateOnChange: false,
    validateOnBlur: false,

    onSubmit: async (values) => {
      let input = {};
      input.exp_cat_name = values.exp_cat_name;
      // input.exp_cat_type = values.exp_cat_type;
      input.exp_cat_id = values.exp_cat_id;
      setIsSubmit(true);
      await $.post(`${config.apiUrl}/expCategory/editExpCategory`, JSON.stringify(input))
        .done(function (res) {
          setSuccess(res.message);
          setError("");
          props.list();
        })
        .catch(function (err) {
          setError(err.responseJSON.data?.message || err.responseJSON.message);
          setSuccess("");
        })
        .always(function () {
          setIsSubmit(false);
          setTimeout(() => {
            setSuccess("");
            setError("");
          }, 5000);
        });
    },
  });
 
  useEffect(function () {}, [success, error]);

  return (
    <>
      <Modal.Header closeButton>
        <h4 style={{ marginLeft: "10rem", height: "4px" }} id="modalhead">
          Edit Expense Category
        </h4>
      </Modal.Header>
      <div className="container-fluid p-4" id="expcatAdd">
        <form
          className="row g-3"
          onSubmit={expenseCategoryFormik.handleSubmit}
          autoComplete="off">
          <div className="col-md-6">
            <label htmlFor="exp_cat_name">
              Expense Category Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              id="exp_cat_name"
              maxLength={50}
              {...expenseCategoryFormik.getFieldProps("exp_cat_name")}
            />
            {expenseCategoryFormik.errors.exp_cat_name ? (
              <div className="text-danger small">
                {expenseCategoryFormik.errors.exp_cat_name}
              </div>
            ) : null}
          </div>
          <div className="col-md-6">
            <label htmlFor="exp_cat_type">
              Expense Category Type <span className="text-danger">*</span>
            </label>
            <select
              type="text"
              className="form-control"
              id="exp_cat_type"
              disabled
              {...expenseCategoryFormik.getFieldProps("exp_cat_type")}>
              <option value="" hidden>
                N/A
              </option>
              {config.expenseCategories.map((list) => (
                <>
                  <option value={list.value}>{list.label}</option>
                </>
              ))}
            </select>
            {expenseCategoryFormik.errors.exp_cat_type ? (
              <div className="text-danger small">
                {expenseCategoryFormik.errors.exp_cat_type}
              </div>
            ) : null}
          </div>
          <div className="col-12 mt-4">
            {(error || success) && (
              <div
                className={`alert alert-${
                  error ? "danger" : "success"
                } py-2 small`}
                role="alert">
                {error || success || ""}
              </div>
            )}
            <div style={{ float: "right" }}>
              <button
                onClick={props.hide}
                className="expcatModalCancel"
                src={cancel}
                type="button">
                Cancel
              </button>
              <button type="submit" disabled={isSubmit}>
                {isSubmit && (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                )}
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default ExpenseCategoryEdit;
